import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import { stepperFormValidationMapper } from "@utilities";
import { STEP_1_VALIDATIONS } from "../../Validations/step1";
import { ClientAdress, ClientProfile, ClientSecondAdress } from "./groups";
import useFormStepControl from "@hooks/useFormStepControl";
import { ActionButtons, ExtraCheckModal } from "../../Components";
import { KYCActions, selectAppPrefillData } from "@redux";

const ADRESS_KEYS = [
  "clientAddress.0.data.addressCountry",
  "clientAddress.0.data.addressCity",
  "clientAddress.0.data.addressStreet",
  "clientAddress.0.data.addressPostCode"
];

const getNextAdressKey = key => {
  const indexKey = key.indexOf(".") + 1;
  return key.substring(0, indexKey) + "1" + key.substring(indexKey + 1);
};

const getModalVisibleData = formInfo => {
  let visibleInfo = {};
  // make deep copy
  const formInfoCopy = JSON.parse(JSON.stringify(formInfo))
  const newDataAddress = formInfoCopy.clientAddress.filter(item => item.addressType === "ADRT2");

  visibleInfo = Object.assign(newDataAddress[0].data);
  visibleInfo.clientPhoneNo = formInfoCopy.clientPhone[0].data.clientPhoneNo;
  visibleInfo.clientEmail = formInfoCopy.clientMail[0].data.clientEmail;

  return visibleInfo;
};

export const FormStep1 = React.memo(() => {
  const dispatch = useDispatch();
  const prefillData = useSelector(selectAppPrefillData)

  const { formDraft, submitForm, isSent } = useFormStepControl();
  const { handleSubmit, control, setValue, getValues, clearErrors } = useForm({
    resolver: values => stepperFormValidationMapper(values, STEP_1_VALIDATIONS),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: formDraft.personData
  });

  const [formInfoEntity, setFormInfoEntity] = useState();

  const openExtraCheckModal = data => {
    setFormInfoEntity(data);
  };

  const onClientSameAdressCheck = useCallback(e => {
    if (!e.target.checked) {
      ADRESS_KEYS.forEach(key => {
        const keyToUpdate = getNextAdressKey(key);
        setValue(keyToUpdate, "");
      });
      return;
    }

    const primaryAdressValues = getValues(ADRESS_KEYS);
    ADRESS_KEYS.forEach((key, index) => {
      const keyToUpdate = getNextAdressKey(key);
      if (primaryAdressValues[index]) {
        setValue(keyToUpdate, primaryAdressValues[index]);
        clearErrors(keyToUpdate);
      }
    });
  }, []);

  const onSubmit = async () => {
    if (prefillData?.company?.country !== "LTU") {
      const response = await dispatch(KYCActions.getCompanyClassification({
        sectorCode: formInfoEntity.clientProfile[0].data.insSect,
        companyType: formInfoEntity.clientProfile[0].data.clientLegalStatus,
        naceCode: formInfoEntity.clientBasicBusiness[0].data.clientBasicBusiness,
      }));
      if (response && response.payload) {
        const formCopy = JSON.parse(JSON.stringify(formInfoEntity))
        Object.assign(formCopy.clientProfile[0].data, response.payload);
        submitForm(formCopy, "next");
        return;
      }
    }
    submitForm(formInfoEntity, "next");
  };

  return (
    <>
      <form onSubmit={handleSubmit(openExtraCheckModal)}>
        <ClientProfile
          control={control}
          companySector={formDraft?.personData?.clientProfile?.[0].data?.insSect}
          setValue={setValue}
        />
        <ClientAdress control={control} />
        <ClientSecondAdress control={control} onCheck={onClientSameAdressCheck} />
        <ActionButtons />
      </form>
      {formInfoEntity && (
        <ExtraCheckModal
          onClose={() => setFormInfoEntity()}
          onConfirm={onSubmit}
          formData={getModalVisibleData(formInfoEntity)}
          isLoading={isSent}
        />
      )}
    </>
  );
});
